import dayjs from 'dayjs';

export const colors = ['#85A5FF', '#597EF7'];

export const currencyFormat = (value: number): string => {
    return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
    }).format(value / 100);
};

export const getChartOptions = (data, filters) => {
    return {
        chart: {
            stacked: true,
            type: 'bar',
            toolbar: {
                show: false,
            },
        },
        labels: data.labels,
        legend: {
            show: false,
            position: 'left',
        },
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            labels: {
                show: filters.period !== 'day',
                formatter(value, timestamp, opts) {
                    switch (filters.period) {
                        case 'year': {
                            return dayjs(timestamp).format('MMMM');
                        }
                        case 'month': {
                            return dayjs(timestamp).format('DD MMMM');
                        }
                        case 'week': {
                            return dayjs(timestamp).format('DD MMMM');
                        }
                    }
                },
            },
            type: 'datetime',
        },
        yaxis: {
            labels: {
                show: false,
            },
        },
        plotOptions: {},
        colors: colors,
        markers: {
            colors: colors,
        },
        tooltip: {
            custom: function (options) {
                return `${
                    options.w.config.series[options.seriesIndex].name
                } ${currencyFormat(
                    options.series[options.seriesIndex][options.dataPointIndex]
                )}`;
            },
        },
    };
};
